import { connect } from "react-redux";
import { form } from "MODULES/shared/components/Forms";
import * as actions from "MODULES/parts/actions";
import Form from "./Form";
import validate from "./validate";

export default connect(
  (state, props) => ({
    initialValues: {
      alternate_type: props.alternate.alternate_type
    }
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(actions.updateAlternate(ownProps.alternate.id, data))
  })
)(
  form({
    form: "editPartAlternate",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/Alternates/EditForm.jsx